export default {
  install(app) {
    app.config.globalProperties.$exportCsv = (data, filename = "data.csv", fields = []) => {
      if (!data || !data.length) return;

      const headers = fields.join(",") + "\n";

      const rows = data
        .map((item) =>
          fields.map((field) => `"${item[field] ?? ""}"`).join(",")
        )
        .join("\n");

      const csvContent = headers + rows;

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    };
  },
};
